const readEnv = (name, fallback = '') => {
  const value = process.env[name];
  return typeof value === 'string' && value.trim() ? value.trim() : fallback;
};

export const BRAND_VARIANT = readEnv('REACT_APP_BRAND_VARIANT', 'default');
export const SERVICE_BRAND_NAME = readEnv('REACT_APP_SERVICE_BRAND_NAME', 'Service');
export const BRAND_COPYRIGHT = readEnv(
  'REACT_APP_BRAND_COPYRIGHT',
  `Copyright 2026 ${SERVICE_BRAND_NAME}. All rights reserved.`,
);
export const OTP_ISSUER = readEnv('REACT_APP_OTP_ISSUER', SERVICE_BRAND_NAME);
export const OTP_SECRET_PREFIX = readEnv('REACT_APP_OTP_SECRET_PREFIX', SERVICE_BRAND_NAME)
  .replace(/[^A-Za-z0-9]/g, '')
  .toUpperCase() || 'SERVICE';
export const RECEIPT_LOGO_URL = readEnv(
  'REACT_APP_RECEIPT_LOGO_URL',
  readEnv('REACT_APP_HEADER_LOGO_URL', '/img/logo_2.png'),
);
export const LOGIN_LAYOUT = readEnv('REACT_APP_LOGIN_LAYOUT', 'centered-card');

export const BRAND_COLORS = Object.freeze({
  primary: readEnv('REACT_APP_BRAND_PRIMARY', '#0064ff'),
  primaryRgb: readEnv('REACT_APP_BRAND_PRIMARY_RGB', '0,100,255'),
  hover: readEnv('REACT_APP_BRAND_PRIMARY_HOVER', '#0052cc'),
  active: readEnv('REACT_APP_BRAND_PRIMARY_ACTIVE', '#004080'),
  soft: readEnv('REACT_APP_BRAND_PRIMARY_SOFT', '#e7f5ff'),
  softStrong: readEnv('REACT_APP_BRAND_PRIMARY_SOFT_STRONG', '#e8ecff'),
  border: readEnv('REACT_APP_BRAND_PRIMARY_BORDER', '#b3d9ff'),
  secondary: readEnv('REACT_APP_BRAND_SECONDARY', '#175CD3'),
  accent: readEnv('REACT_APP_BRAND_ACCENT', '#69073F'),
  disabled: readEnv('REACT_APP_BRAND_PRIMARY_DISABLED', '#93c5fd'),
  gradientStart: readEnv('REACT_APP_BRAND_GRADIENT_START', '#0b3a6f'),
  gradientMid: readEnv('REACT_APP_BRAND_GRADIENT_MID', '#0d2b53'),
  gradientEnd: readEnv('REACT_APP_BRAND_GRADIENT_END', '#08223f'),
  pageBackground: readEnv('REACT_APP_BRAND_PAGE_BACKGROUND', '#f2f4f6'),
  focusRing: readEnv('REACT_APP_BRAND_FOCUS_RING', 'rgba(49,130,246,0.3)'),
});

export const BRAND_CSS_VARIABLES = Object.freeze({
  '--brand-primary': BRAND_COLORS.primary,
  '--brand-primary-hover': BRAND_COLORS.hover,
  '--brand-primary-rgb': BRAND_COLORS.primaryRgb,
  '--brand-primary-active': BRAND_COLORS.active,
  '--brand-primary-soft': BRAND_COLORS.soft,
  '--brand-primary-soft-strong': BRAND_COLORS.softStrong,
  '--brand-primary-border': BRAND_COLORS.border,
  '--brand-secondary': BRAND_COLORS.secondary,
  '--brand-accent': BRAND_COLORS.accent,
  '--brand-primary-disabled': BRAND_COLORS.disabled,
  '--brand-gradient-start': BRAND_COLORS.gradientStart,
  '--brand-gradient-mid': BRAND_COLORS.gradientMid,
  '--brand-gradient-end': BRAND_COLORS.gradientEnd,
  '--brand-page-background': BRAND_COLORS.pageBackground,
  '--brand-focus-ring': BRAND_COLORS.focusRing,
});

export const applyBrandTheme = (target) => {
  if (!target) return null;
  Object.entries(BRAND_CSS_VARIABLES).forEach(([name, value]) => target.style.setProperty(name, value));
  target.dataset.brand = BRAND_VARIANT;
  return target;
};

export const brandPageAttributes = {
  'data-brand': BRAND_VARIANT,
  'data-layout': LOGIN_LAYOUT,
};
